{
  "fr": {
    "logged_out": {
      "success": {
        "login": "Se reconnecter",
        "title": "Votre session est terminée !"
      }
    }
  }
}
